import React, { useEffect } from "react";
import { ISystemMessage, MessageType } from "../interfaces/App";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, IApplicationState } from "../stores/AppStore";
import { readSystemMessage } from "../stores/AppReducer";


function Messages() {
    const app = useSelector((appState: IApplicationState) => appState.app);
    const dispatch = useDispatch<AppDispatch>();
    const boxRef: React.RefObject<HTMLDivElement> = React.createRef();
    const showMessage = (m: ISystemMessage, idx: number) => {
        const className = "messages " + (m.type === MessageType.success 
        ? "success"
        : m.type === MessageType.error
            ? "error"
            : m.type === MessageType.hint
                ? "hint"
                : "");
        return (
            <div key={"msg_" + idx} className={className} onClick={() => dispatch(readSystemMessage(m.timestamp))}>{m.msg}</div>
        );
    };
    // useEffect(() => {
    //     if (!boxRef.current) return;

    // }, []);
    useEffect(() => {
        if (!boxRef.current) return;
        boxRef.current.scrollTop = boxRef.current.scrollHeight;
    }, [app.status]);
    return (
        <div className="sys_messsages">
            <div className="_sys_message_content" ref={boxRef} onMouseEnter={() => {
         //       const shift = String((boxRef.current.scrollHeight - boxRef.current.clientHeight) * - 1) + "px";
         //       boxRef.current.style.setProperty("--shift-up", `${shift}px`);
            }}>
                {app.status?.filter((m: ISystemMessage) => !m.read).reverse().map(showMessage)}
            </div>
        </div>
    );
}

export default (Messages);
